<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "SCHEDULE_DETAILS_PREVIEW" | translate | titlecase }} - <a type="button" class="btn btn-primary" routerLink="/schedule/schedule-details"
                    [queryParams]="{scheduleId: scheduleSetupId, yearid: yearid, semesterid: semesterid, gradeid: gradeid}">{{
                        "BACK" | translate | titlecase }}</a></h5>
                <app-loader [show]="showLoader"></app-loader>
                <div class="table-responsive py-3" *ngIf="!showLoader" style="padding: 10px;">
                    <div class="row">
                        <div class="col-sm-1">
                            <button (click)="generateExcel()" class="btn" style="height:auto"><span
                                    style="font-size: 2em; color: green;"><i
                                        class="fas fa-file-excel fa-sm"></i></span></button>
                        </div>
                    </div>
                    <br />
                    <table  class="table table-bordered" id="datatable">
                        <thead>
                            <tr>
                                <th *ngFor="let res of ScheduleHeader">{{res.data}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of ScheduleData">
                                <th *ngFor="let colm of data" [attr.colspan]="colm.colspan">{{colm.data}}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>